import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import StepOne from '../1/StepOne';
import PageBuilder from '../../../pageBuilder/PageBuilder';

Vue.use(VueFormGenerator);

export default {

  name: 'StepTwo',

  inject: [
    'removeFromCart',
    'storageData',
    'stepValidation',
    'pageBuilderData',
    'saveStorageData',
    'getEventByUuid'
  ],

  components: {
    'page-builder': PageBuilder
  },

  data () {
    return {
      formData: [],
      formOptions: {
        validateAfterChanged: true
      }
    };
  },

  watch: {
    formData: {
      handler: function (val, oldVal) {
        //
      },
      deep: true
    }
  },

  methods: {
    onValidated (isValid, errors) {
      if (!isValid) {
        this.isStepValid = false;
        Vue.set(this.stepValidation, 'triedToValidateStep', true);
      }
    },

    validateStep: function () {
      // emit event to all FormBuilderBlocks to check if there valid

      this.$eventBus.$emit('validateAllPageBuilderForms');

      // avoid next step. one of the PB Forms not valid
      Vue.set(this.stepValidation, 'isValid', this.pageBuilderData.allFormsValid);

      // after the step is marked as invalid, we have to put allFormValid to true for the next try
      Vue.set(this.pageBuilderData, 'allFormsValid', true);
    }
  },

  created () {
    this.$parent.$off('validateCurrentStep').$on('validateCurrentStep', this.validateStep);
    for (let eventUuid in this.storageData.cart) {
      let cartEntry = this.storageData.cart[eventUuid];
      if (!this.storageData.forms.stepThree.hasOwnProperty(eventUuid)) {
        Vue.set(this.storageData.forms.stepThree, eventUuid, {});
      }
      for (let selectedVKey in cartEntry.selectedVarieties) {
        let selectedVariety = cartEntry.selectedVarieties[selectedVKey];
        if (!this.storageData.forms.stepThree[eventUuid].hasOwnProperty(selectedVKey)) {
          Vue.set(this.storageData.forms.stepThree[eventUuid], selectedVKey, {});
        }
        let count = 1;
        while (count <= selectedVariety.amount) {
          if (!this.storageData.forms.stepThree[eventUuid][selectedVKey].hasOwnProperty(count)) {
            Vue.set(this.storageData.forms.stepThree[eventUuid][selectedVKey], count, {});
          }

          count++;
        }
      }
    }
  },

  mounted () {
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/bookingSteps/defaultSteps/3/StepThree.js